<template>
    <div class="finance-panel-boxes-container">
        <finance-panel-box v-for="item in data" :key="item.id" :data="item"/>
    </div>
</template>

<script>
    import FinancePanelBox from "./FinancePanelBox";
    export default {
        name: "PropertyPanelBoxesContainer",
        props: ['data'],
        components: {
	        FinancePanelBox
        }
    }
</script>

<style scoped lang="scss">
    .finance-panel-boxes-container {
        .finance-panel-box {
            margin-bottom: 15px;
            &:last-child {
                margin-bottom: 0;
            }
        }
    }
</style>